<section class="faq-section" *ngIf="items.length" [attr.id]="sectionId"
         [attr.data-aos]="animated ? 'fade-up' : null">
    <div class="faq-section__head">
        <div class="faq-section__eyebrow" *ngIf="eyebrow">{{ eyebrow }}</div>
        <h2>{{ title }}</h2>
        <p *ngIf="description">{{ description }}</p>
    </div>

    <div class="faq-section__grid">
        <article class="faq-section__item" *ngFor="let item of items; let itemIndex = index" itemscope
                 [attr.data-aos]="animated ? 'fade-up' : null"
                 [attr.data-aos-delay]="getAnimationDelay(itemIndex)"
                 itemtype="https://schema.org/Question">
            <h3 itemprop="name">{{ item.question }}</h3>
            <div itemprop="acceptedAnswer" itemscope itemtype="https://schema.org/Answer">
                <p itemprop="text">{{ item.answer }}</p>
            </div>
        </article>
    </div>
</section>
